import { AuthContext } from "@redotech/redo-merchant-app-common/auth";
import { REDO_MERCHANT_SERVER_URL } from "@redotech/redo-merchant-app-common/config";
import {
  createRedoAutomationsRpcClient,
  RedoAutomationsRpcClient,
} from "@redotech/redo-merchant-automations-rpc/client";
import { useContext, useMemo } from "react";

/** The `/automations-rpc` client for the signed-in team; undefined while signed out. */
export function useAutomationsRpcClient():
  | RedoAutomationsRpcClient
  | undefined {
  const auth = useContext(AuthContext);
  return useMemo(
    () =>
      auth
        ? createRedoAutomationsRpcClient({
            baseURL: new URL(`${REDO_MERCHANT_SERVER_URL}/automations-rpc`),
            headers: { Authorization: auth.token },
          })
        : undefined,
    [auth],
  );
}
